import { TourConfig } from '../models/tour-config.model';
import { TourFeature } from '../config/tour-feature.enum';
import { Audience } from '../config/audience.enum';
import { TourTrigger } from '../config/trigger.enum';
import { AnchorId } from '../config/anchor.registry';

/**
 * MENTOR AP-8 (§7a) — Folgen-Hilfe „Planung aufraeumen" (E-Del-2, Bulk-Modus).
 *
 * Kontextuelle `?`-Tour fuer den `bulk-delete-staffing-dialog` im Bulk-Modus
 * (3-Schritt-Wizard: Auswahl → Zeitraum → Folgen pruefen). Der `?`-Button wird
 * nur im Bulk-Modus eingeblendet (nicht im Single-Item-Loeschen).
 *
 * Bewusst eine ueberblickende Erklaerung, die den Wizard NICHT weitertreibt:
 * sie erklaert das Drei-Schritt-Prinzip und den Vergangenheits-Schutz auf
 * Schritt 1. Kein deterministischer Opener-Anker → KEIN `launchContext`.
 */
const DIALOG_CTX = { attachToDialog: true, autoCloseOnDialogClose: true };

export const CLEANUP_PLANNING_HELP_TOUR: TourConfig = {
  id: TourFeature.CleanupPlanningHelp,
  version: 1,
  title: 'TUTORIAL.CLEANUP_PLANNING.TITLE',
  description: 'TUTORIAL.CLEANUP_PLANNING.DESC',
  audience: [Audience.Admin, Audience.TeamLeader],
  triggers: [TourTrigger.Manual],
  statePolicy: {
    allowReplay: true,
    snoozeEnabled: false,
    cooldownHoursAfterDismiss: 0,
    cooldownHoursAfterSnooze: 0,
    suppressAfterCompletion: false,
  },
  priority: 100,
  estimatedDurationSec: 75,
  category: 'feature-discovery',
  chapters: [
    {
      id: 'overview',
      title: 'TUTORIAL.CLEANUP_PLANNING.TITLE',
      steps: [
        {
          // Was ist Aufraeumen + Vergangenheits-Schutz (Sicherheitsbruecke).
          id: 'welcome',
          anchor: AnchorId.CleanupPlanningDialog,
          spotlightAnchor: AnchorId.CleanupPlanningDialog,
          title: 'TUTORIAL.CLEANUP_PLANNING.WELCOME.TITLE',
          content: 'TUTORIAL.CLEANUP_PLANNING.WELCOME.CONTENT',
          placement: 'right',
          dialogContext: { ...DIALOG_CTX, popoverOutsideDialog: true },
          nextCondition: 'manual',
          showNextButton: true,
          showPrevButton: false,
        },
        {
          // Die drei Schritte: Auswahl → Zeitraum → Folgen pruefen.
          id: 'steps',
          anchor: AnchorId.CleanupPlanningSteps,
          spotlightAnchor: AnchorId.CleanupPlanningSteps,
          title: 'TUTORIAL.CLEANUP_PLANNING.STEPS.TITLE',
          content: 'TUTORIAL.CLEANUP_PLANNING.STEPS.CONTENT',
          placement: 'bottom',
          dialogContext: DIALOG_CTX,
          nextCondition: 'manual',
          showNextButton: true,
        },
        {
          // Schritt 1: was raeumst du auf (Muster/manuelle Planung waehlen).
          id: 'selection',
          anchor: AnchorId.CleanupPlanningSelection,
          spotlightAnchor: AnchorId.CleanupPlanningSelection,
          title: 'TUTORIAL.CLEANUP_PLANNING.SELECTION.TITLE',
          content: 'TUTORIAL.CLEANUP_PLANNING.SELECTION.CONTENT',
          placement: 'top',
          dialogContext: DIALOG_CTX,
          nextCondition: 'manual',
          showNextButton: true,
          // Schritt-1-Inhalt nur sichtbar, solange der Wizard auf Schritt 1 steht.
          skipIf: () =>
            !document.querySelector('[onboardingAnchor="cleanup-planning-selection"]'),
        },
      ],
    },
  ],
};
